
<div class="container">
  <div class="frame-124">
    <div class="item">
      <div class="content">
        <div class="frame-121">
          <div class="idea">Idea</div>
        </div>
        <div class="frame-79">
          <div class="frame-90">
            <div class="impact-0-10">
              <span>
                <span class="impact-0-10-span">
                  Impact
                  <br />
                </span>
                <span class="impact-0-10-span2">[0-10]</span>
              </span>
            </div>
          </div>
          <div class="frame-92">
            <div class="confidence-0-10">
              <span>
                <span class="impact-0-10-span">
                  Confidence
                  <br />
                </span>
                <span class="impact-0-10-span2">[0-10]</span>
              </span>
            </div>
          </div>
          <div class="frame-91">
            <div class="ease-0-10">
              <span>
                <span class="impact-0-10-span">
                  Ease
                  <br />
                </span>
                <span class="impact-0-10-span2">[0-10]</span>
              </span>
            </div>
          </div>
          <div class="frame-93">
            <div class="ice-score-i-x-c-x-e">
              <span>
                <span class="ice-score-i-x-c-x-e-span">
                  ICE Score
                  <br />
                </span>
                <span class="ice-score-i-x-c-x-e-span2">[I x C x E]</span>
              </span>
            </div>
          </div>
        </div>
      </div>
    </div>
    @for (item of items; track item.label; let i = $index) {
    <div class="item2">
      <div class="content">
        <div class="frame-121">
          <div class="frame-131">
            <div class="example-item" (click)="enterLabel(i)">
              @if (editedLabel == i) {
                <input class="item-input" type="text" [(ngModel)]="item.label" (change)="updateLabel(i)"/>
              } @else {
                {{item.label}}
              }
            </div>
          </div>
        </div>
        <div class="frame-79">
          <div class="_7" (click)="enterImpact(i)">
            @if (editedImpact == i) {
              <input class="item-input" type="number" [(ngModel)]="item.impact" (change)="updateImpact(i)"/>
            } @else {
              {{item.impact}}
            }
          </div>
          <div class="_2" (click)="enterConfidence(i)">
            @if (editedConfidence == i) {
              <input class="item-input" type="number" [(ngModel)]="item.confidence" (change)="updateConfidence(i)"/>
            } @else {
              {{item.confidence}}
            }
          </div>
          <div class="_8" (click)="enterEase(i)">
            @if (editedEase == i) {
              <input class="item-input" type="number" [(ngModel)]="item.ease" (change)="updateEase(i)"/>
            } @else {
              {{item.ease}}
            }
          </div>
          <div class="_112">{{item.score}}</div>
          <div class="delete-button">
            <img class="x" src="../../assets/x.svg" (click)="deleteItem(i)"/>
          </div>
        </div>
      </div>
    </div>
    }
    <div class="add-button" (click)="addItem()">
      <img class="circle-plus" src="../../assets/circle-plus.png" />
      <div class="button-label">Add new</div>
    </div>
  </div>
  
</div>
